import styles from './Calendar.module.scss'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'

const CalendarLegend = ({ isHidden }) => {
  if(isHidden) {
    return null
  }
  return (
    <div className={styles.tableLegend}>
      <span className={cx(styles.legendItem, styles.most)}>
        <FormattedMessage
          id='most_sightings'
          defaultMessage='Most likely sightings'
        />
      </span>
      <span className={cx(styles.legendItem, styles.possible)}>
        <FormattedMessage
          id='possible_sightings'
          defaultMessage='Possible sightings'
        />
      </span>
      <span className={cx(styles.legendItem, styles.unlikely)}>
        <FormattedMessage id='unlikely_sightings' defaultMessage='Unlikely' />
      </span>
    </div>
  )
}

export default CalendarLegend
